type LogContext =
  | "HAMRS_CLIENT"
  | "HAMRS_API"
  | "HAMRS_SYNC"
  | "LOCATION"
  | "PROFILES"
  | "LOOKUPS"
  | "LOGGER"
  | "OPERATORS"
  | "POTA_PARKS"
  | "POUCH"
  | "SOTA"
  | "WSJT_X"
  | "RIG_CONTROL";

export const LOG_EMOJIS: Record<LogContext, string> = {
  HAMRS_CLIENT: "📱",
  HAMRS_API: "📡",
  HAMRS_SYNC: "🔄",
  PROFILES: "👤",
  LOOKUPS: "🔍",
  LOGGER: "🪵",
  LOCATION: "📍",
  OPERATORS: "👥",
  POTA_PARKS: "🏕️",
  SOTA: "🏔️",
  POUCH: "💾",
  WSJT_X: "🌐",
  RIG_CONTROL: "🎮",
};

function createLogger(
  context: LogContext,
  emoji: string
): (...args: any[]) => void {
  return function (...args: any[]) {
    console.log(emoji, `[${context.replace("_", " ")}]`, ...args);
  };
}

export const profilesLogger = createLogger("PROFILES", LOG_EMOJIS.PROFILES);
export const lookupsLogger = createLogger("LOOKUPS", LOG_EMOJIS.LOOKUPS);
export const hamrsClientLogger = createLogger(
  "HAMRS_CLIENT",
  LOG_EMOJIS.HAMRS_CLIENT
);
export const hamrsApiLogger = createLogger("HAMRS_API", LOG_EMOJIS.HAMRS_API);
export const loggerLogger = createLogger("LOGGER", LOG_EMOJIS.LOGGER);
export const locationLogger = createLogger("LOCATION", LOG_EMOJIS.LOCATION);
export const potaParksLogger = createLogger("POTA_PARKS", LOG_EMOJIS.POTA_PARKS);
export const pouchLogger = createLogger("POUCH", LOG_EMOJIS.POUCH);
export const sotaLogger = createLogger("SOTA", LOG_EMOJIS.SOTA);
export const rigControlLogger = createLogger("RIG_CONTROL", LOG_EMOJIS.RIG_CONTROL);
export const hamrsSyncLogger = createLogger("HAMRS_SYNC", LOG_EMOJIS.HAMRS_SYNC);
export const wsjtXLogger = createLogger("WSJT_X", LOG_EMOJIS.WSJT_X);
export const operatorsLogger = createLogger("OPERATORS", LOG_EMOJIS.OPERATORS);
